<!--
 * @Author: wjl
 * @Date: 2020-12-31 15:58:59
 * @LastEditors: wjl
 * @LastEditTime: 2020-12-31 16:35:09
 * @FilePath: \appOfficial\src\views\synopsis.vue
-->
<template>
  <div class="contrainer" :style="isPc ? 'width:1100px' : ''">
    <h1>关于网上老年大学</h1>
    <p>
      网上老年大学是<span>全国老年大学线上官方学习平台</span>，目前已近
      <span>600所老年大学加入</span>。
    </p>
    <p>
      在<span>中国老年大学协会</span>的领导下,网上老年大学<i>对全国中老年人开放，永久保留学位</i>，活到老，学到老；
      <span>网上老年大学</span
      >根据中老年人的兴趣爱好，汇聚全国优秀师资力量，广开<i>200余门优质直播课程</i>，让更多的老年人<span>足不出户</span>就能享受到优秀的教学资源。
    </p>
    <p>
      更多体验请下载<i>网上老年大学APP</i>，课程内容<span> 更丰富</span
      >，界面<span>更清晰</span>；师生直接在线交流、上课通知、作业提醒、一步到位，打破时间、空间限制，随时随地都能学……
    </p>
    <h2><span>手机扫一扫下载网上老年大学APP</span></h2>
    <img src="@/images/qr.jpg" alt="" srcset="" />
  </div>
</template>

<script>
export default {
  name: "synopsis",
  data() {
    return {
      isPc: true,
    };
  },
  mounted() {
    this.isPc = this.modoule();
  },
  methods: {
    modoule() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      );
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
  },
};
</script>

<style lang="scss" scoped>
.contrainer {
  padding: 20px;
  padding-top: 0;
  margin: 0 auto;
  h1 {
    font-size: 1.5rem;
    text-align: center;
    color: #000;
    margin-top: 10px;
  }
  p {
    text-align: justify;
    line-height: 2.5em;
    margin-left: 5px;
    margin-right: 5px;
    clear: both;
    min-height: 1em;
    color: #333;
    font-size: 17px;
    font-family: 微软雅黑, "Microsoft YaHei";
    span {
      font-weight: 800;
    }
    i {
      font-weight: 800;
      color: #ba282e;
      font-style: normal;
    }
  }
  h2 {
    span {
      background-color: rgb(192, 0, 0);
      visibility: visible;
    }
    font-size: 20px;
    color: rgb(255, 255, 255);
    font-family: 微软雅黑, "Microsoft YaHei";
    text-align: center;
    margin: 1.25rem;
    line-height: 1.875rem;
  }
  img {
    display: block;
    margin: 0 auto;
    width: calc(466vmin / 7.5);
    height: calc(466vmin / 7.5);
    text-align: center;
  }
}
</style>
